import { render, staticRenderFns } from "./UploadProfileImage.vue?vue&type=template&id=5f1f6950"
import script from "./UploadProfileImage.vue?vue&type=script&lang=js"
export * from "./UploadProfileImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports